/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.037Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { getLabelByKeyContract } from '@/lib/contracts/labels';

// ============================================
// Types
// ============================================

export type GetLabelByKeyResponse = InferContract<typeof getLabelByKeyContract>['response'];
export type GetLabelByKeyParams = InferContract<typeof getLabelByKeyContract>['params'];

// ============================================
// API Functions
// ============================================

/**
 * GET /_cms/labels/by-key/:key
 */
export const getLabelByKey = (options: { params: GetLabelByKeyParams }) => client.call(getLabelByKeyContract, options);

